import { MessagePrimitive } from '@assistant-ui/react';
import { type FC, useContext } from 'react';
import { RecommendationsTool, RecommendationsToolName } from '../recommendations-tool';
import { AssistantAvatarContext } from './AssistantAvatarContext';
import { MarkdownText } from './MarkdownText';
import './AssistantMessage.scss';

export const AssistantMessage: FC = () => {
  const avatar = useContext(AssistantAvatarContext);
  return (
    <MessagePrimitive.Root asChild>
      <section className={'chat-message chat-ai-message'}>
        <figure className={'chat-avatar is-hidden-mobile'}>
          <p className={'image is-32x32'}>
            <img src={avatar.uri} alt={avatar.altText} />
          </p>
        </figure>
        <main className={'chat-message-content'}>
          <MessagePrimitive.Content
            components={{
              tools: {
                by_name: {
                  [RecommendationsToolName]: RecommendationsTool,
                },
              },
              Text: MarkdownText,
            }}
          />
        </main>
      </section>
    </MessagePrimitive.Root>
  );
};
AssistantMessage.displayName = 'AssistantMessage';
